// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import translate from "@insite/client-framework/Translate";
import Checkbox, { CheckboxProps } from "@insite/mobius/Checkbox";
import { IconWrapper } from "@insite/mobius/Icon";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import activateRestrictedProducts from "@store/Framework/Store/Data/RestrictedProductsToggle/Handlers/ActivateRestrictedProductsToggle";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

interface OwnProps {}

const mapStateToProps = (state: ApplicationState) => ({});

const mapDispatchToProps = {
    activateRestrictedProducts,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface RestrictedProductToggleStyles {
    restrictedProductsLabel?: InjectableCss;
    restrictedProductsToggle?: CheckboxProps;
}

const restrictedProductToggleStyles: RestrictedProductToggleStyles = {
    restrictedProductsLabel: {
        css: css`
            margin-right: ${pxToRem(10)};
            font-weight: ${x => x.theme.design.typography.weight.medium};
        `,
    },
    restrictedProductsToggle: {
        variant: "toggle",
        labelPosition: "right",
        css: css`
            align-items: center;
            > div {
                &[aria-checked="false"] {
                    background-color: transparent !important;
                    border-color: ${getColor("common.border")} !important;
                    color: ${getColor("icon")};
                }

                &[aria-checked="true"] {
                    background-color: transparent !important;
                    border-color: ${getColor("common.border")} !important;
                    color: ${getColor("secondary.light")};
                }
            }

            ${IconWrapper} {
                &:first-child,
                &:last-child {
                    visibility: hidden;
                }
            }
        `,
        typographyProps: {
            css: css`
                font-size: ${x => x.theme.design.typography.size.smaller};
            `,
        },
    },
};

const styles = restrictedProductToggleStyles;

const RestrictedProductToggle: React.FC<Props> = ({ activateRestrictedProducts }) => {
    const [restrictedProductsValue, setRestrictedProductsValue] = React.useState(false);
    const [restrictedProductsLabel, setRestrictedProductsLabel] = React.useState(translate("Off"));

    const restrictedProductsChangeHandler = (value: boolean) => {
        setRestrictedProductsValue(value);
        activateRestrictedProducts({ isRestrictedProductsActivated: value });
        window.location.reload();
    };

    React.useEffect(() => {
        const storedIsRestrictedProductsToggleOn = localStorage.getItem("isRestrictedProductsToggleOn");
        if (storedIsRestrictedProductsToggleOn !== null) {
            setRestrictedProductsValue(storedIsRestrictedProductsToggleOn === "true");
        }
    }, []);

    React.useEffect(() => {
        setRestrictedProductsLabel(restrictedProductsValue ? translate("On") : translate("Off"));
    }, [restrictedProductsValue]);

    return (
        <>
            <StyledWrapper {...styles.restrictedProductsLabel}>{translate("Resctricted Products")}</StyledWrapper>
            <Checkbox
                {...styles.restrictedProductsToggle}
                checked={restrictedProductsValue}
                onChange={(e, value) => restrictedProductsChangeHandler(value)}
                data-test-selector="restrictedProductToggle"
            >
                {restrictedProductsLabel}
            </Checkbox>
        </>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(RestrictedProductToggle);
